import React, { useState, useEffect } from "react";
import "./SoPrintTemplate.css";

export default function SoPrintTemplate({ so }) {
  const [copyType, setCopyType] = useState("OFFICE");

  useEffect(() => {
    const handler = (e) => setCopyType(e.detail);
    window.addEventListener("SET_COPY_TYPE", handler);
    return () => window.removeEventListener("SET_COPY_TYPE", handler);
  }, []);

  if (!so) return null;

  const formatMoney = (value) => {
    const num = Number(value || 0);
    return num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const formatQty = (value) => {
    const num = Number(value || 0);
    return num.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  };

  const subtotal = Number(so.Subtotal || 0);
  const vat = Number(so.VAT || 0);
  const grandTotal = Number(so.GrandTotal || subtotal + vat);

  const vatApplicable =
    (so.vat_option || so.VATOption || "").toString().toLowerCase() === "yes";

  const copyNote =
    copyType === "OFFICE"
      ? "WHITE - OFFICE FILE"
      : "YELLOW - SALESMAN'S COPY";

  return (
    <div className="so-print">
      <div className="so-header-row-1">
        <img
          src="/img/biocare-logo.png"
          alt="Biocare Logo"
          className="so-logo"
        />

        <div className="so-company-text">
          <strong>BIOCARE, INC.</strong><br />
          Room 306 WEBJET Bldg., 64 Quezon Avenue,<br />
          B.M.A. Ave., Tatalon, Quezon City<br />
          Telephone: 8732-0535, 8712-0531<br />
          8714-9159, 8712-5389<br />
          Fax: (02) 8711-4310<br />
          VAT REG. TIN: 006-163-782-000
        </div>

        <div className="so-header-right">
          <div className="so-ref-label">REFER TO THIS NUMBER</div>

          <table className="so-num-table">
            <thead>
              <tr>
                <th>DAY</th>
                <th>MO</th>
                <th>YR</th>
                <th>NUMBER</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{so.SODate?.slice(8, 10)}</td>
                <td>{so.SODate?.slice(5, 7)}</td>
                <td>{so.SODate?.slice(2, 4)}</td>
                <td className="so-number">{so.SONumber}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="so-header-row-2">
        <div className="so-title">SALES ORDER</div>
      </div>

      <div className="so-contact-row">
        <div className="contact-col">
          <div className="contact-label">SOLD TO</div>
          <div className="contact-text">{so.CustomerName}</div>
        </div>
        <div className="contact-col">
          <div className="contact-label">SHIP TO</div>
          <div className="contact-text">{so.ShipTo}</div>
        </div>
        <div className="contact-col">
          <div className="contact-label">MARK TO</div>
          <div className="contact-text">{so.MarkTo || ""}</div>
        </div>
      </div>

      <table className="so-customer-info">
        <tbody>
          <tr>
            <td>
              <div className="label">CUSTOMER NUMBER</div>
              <div className="value">{so.CustomerNumber || ""}</div>
            </td>
            <td>
              <div className="label">AREA CODE</div>
              <div className="value">{so.AreaManagerCode || ""}</div>
            </td>
            <td>
              <div className="label">REFERENCE ORDER</div>
              <div className="value">{so.ReferenceOrder || ""}</div>
            </td>
            <td>
              <div className="label">DATE</div>
              <div className="value">
                {so.SODate
                  ? new Date(so.SODate).toLocaleDateString("en-PH")
                  : ""}
              </div>
            </td>
            <td>
              <div className="label">SHIPPING INSTRUCTION</div>
              <div className="value">{so.ShippingInstruction || ""}</div>
            </td>
            <td>
              <div className="label">TERMS OF PAYMENT</div>
              <div className="value">{so.TermsOfPayment || ""}</div>
            </td>
          </tr>
        </tbody>
      </table>

      <div className="so-special">
        <div className="label">SPECIAL INSTRUCTIONS</div>
        <div className="value">{so.SpecialInstruction || ""}</div>
      </div>

      <table className="so-item-table">
        <thead>
          <tr>
            <th>QUANTITY</th>
            <th>UNIT</th>
            <th>CATALOG NO</th>
            <th>DESCRIPTION</th>
            <th>UNIT PRICE</th>
            <th>EXTENSION</th>
          </tr>
        </thead>

        <tbody>
          {(so.items || []).map((item, i) => (
            <tr key={i}>
              <td>{formatQty(item.Quantity)}</td>
              <td>{item.UnitOfMeasure}</td>
              <td>{item.CatalogNo || item.CurrentCatalogNo}</td>
              <td>{item.ItemName || item.CurrentItemName}</td>
              <td>{formatMoney(item.InitialPrice)}</td>
              <td>{formatMoney(item.InitialExtensionPrice)}</td>
            </tr>
          ))}
        </tbody>

        <tfoot>
          <tr>
            <td colSpan="4"></td>
            <td className="total-label">SUBTOTAL:</td>
            <td>{formatMoney(subtotal)}</td>
          </tr>

          {vatApplicable ? (
            <tr>
              <td colSpan="4"></td>
              <td className="total-label">VAT (12%):</td>
              <td>{formatMoney(vat)}</td>
            </tr>
          ) : null}

          <tr>
            <td colSpan="4"></td>
            <td className="total-label grand-total">GRAND TOTAL:</td>
            <td className="grand-total">{formatMoney(grandTotal)}</td>
          </tr>
        </tfoot>
      </table>

      <div className="so-clauses">
        <strong>SPECIAL CLAUSE(S): </strong>
        1. Provided that the customer has no pending clause and/or is in good
        credit standing with the company. 2. Items can be returned within 3 days
        for Metro Manila, 7 days for provinces upon receipt of invoice & goods,
        provided items are returned sealed and received in good condition. 3.
        Please prepare Cheque payable to BIOCARE HEALTH RESOURCES. 4.
        Deliveries: 48 hours Metro Manila / 7 working days provinces.
      </div>

      <div className="so-collection-row">
        <div className="collection-left">
          <div className="label">COLLECTION DATE</div>
          <div className="line">
            AMOUNT REMITTED _______________________________
          </div>
          <div className="line">INVOICE NO. __________________________________</div>
          <div className="line">
            OFFICIAL RECEIPT NO. _________________________
          </div>
          <div className="line">
            DATE OF OFFICIAL RECEIPT _____________________
          </div>
        </div>

        <div className="collection-right">
          <div className="line">CONFORME _____________________________________</div>
        </div>
      </div>

      <div className="copy-note">{copyNote}</div>
    </div>
  );
}